export type TypographyVariant =
  | 'body'
  | 'body-sm'
  | 'body-xs'
  | 'dot-lg'
  | 'label-sm'
  | 'label'
  | 'number-lg'
  | 'number-lg-secondary'
  | 'number-lg-discount'
  | 'number-lg-sale'
  | 'number'
  | 'number-sm'
  | 'number-secondary'
  | 'number-sm-secondary'
  | 'number-sm-discount'
  | 'number-sm-sale'
  | 'number-discount'
  | 'link'
  | 'link-sm'
  | 'link-content'
  | 'link-content-sm'
  | 'link-secondary'
  | 'link-sm-secondary'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'hero'

export const FontWeight = {
  light: '300',
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
} as const

export type FontWeightName = keyof typeof FontWeight
export type FontWeightValue = (typeof FontWeight)[FontWeightName]
